module.exports = __webpack_public_path__ + "static/media/logo_zara.4275d2e0.png";